import {
  Component,
  Directive,
  Input,
  OnChanges,
  OnInit,
  Optional,
  ViewEncapsulation,
  NgModule,
  ModuleWithProviders,
  SimpleChanges
} from '@angular/core';
import {
  MdlError,
  MdlStructureError
} from '../common/mdl-error';
import { toNumber } from '../common/number.property';

export class MdlUnsupportedCountOfListItemLinesError extends MdlError {
  constructor(lines: number|string) {
    super(`"${lines}" is not supported - max 3 lines please.`);
  }
}


export class MdlListComponent {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-list',
  host: {
    '[class.mdl-list]': 'true'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}



export class MdlListItemComponent implements OnInit, OnChanges {

  private _lines: number = 1;
  
  get lines() { return this._lines; }
  set lines(value) { this._lines = toNumber(value); }

  constructor( private mdlListComponent: MdlListComponent) {}

  public ngOnInit() {
    if (this.mdlListComponent === null) {
      throw new MdlStructureError('mdl-list-item', 'mdl-list');
    }
  }

  public ngOnChanges(changes: SimpleChanges) {

    if (this.lines && this.lines > 3) {
      throw new MdlUnsupportedCountOfListItemLinesError(this.lines);
    }
  }


  /**
   * TODO check these conditions
   * .mdl-list__item-secondary-content	Defines the secondary content sub-division
   * requires .mdl-list__item-two-line or .mdl-list__item-three-line
   .mdl-list__item-secondary-info	Defines the information sub-division
   requires .mdl-list__item-two-line or .mdl-list__item-three-line
   .mdl-list__item-secondary-action	Defines the Action sub-division
   requires .mdl-list__item-two-line or .mdl-list__item-three-line
   .mdl-list__item-text-body	Defines the Text Body sub-division
   requires .mdl-list__item-three-line
   */
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-list-item',
  host: {
    '[class.mdl-list__item]': 'true',
    '[class.mdl-list__item--two-line]': 'lines==2',
    '[class.mdl-list__item--three-line]': 'lines==3'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdlListComponent, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'lines': [{ type: Input },],
};
}


export class MdlListItemPrimaryContentComponent implements OnInit {

  constructor( private mdlListItemComponent: MdlListItemComponent) {}

  public ngOnInit() {
    if (this.mdlListItemComponent === null) {
      throw new MdlStructureError('mdl-list-item-primary-content', 'mdl-list-item');
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-list-item-primary-content',
  host: {
    '[class.mdl-list__item-primary-content]': 'true'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdlListItemComponent, decorators: [{ type: Optional }, ]},
];
}



export class MdlListItemSecondaryContentComponent implements OnInit {

  constructor( private mdlListItemComponent: MdlListItemComponent) {}

  public ngOnInit() {
    if (this.mdlListItemComponent === null) {
      throw new MdlStructureError('mdl-list-item-secondary-content', 'mdl-list-item');
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-list-item-secondary-content',
  host: {
    '[class.mdl-list__item-secondary-content]': 'true'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdlListItemComponent, decorators: [{ type: Optional }, ]},
];
}


export class MdlListItemSecondaryActionComponent implements OnInit {

  constructor( private mdlListItemComponent: MdlListItemComponent) {}

  public ngOnInit() {
    if (this.mdlListItemComponent === null) {
      throw new MdlStructureError('mdl-list-item-secondary-action', 'mdl-list-item');
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-list-item-secondary-action',
  host: {
    '[class.mdl-list__item-secondary-action]': 'true'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdlListItemComponent, decorators: [{ type: Optional }, ]},
];
}


export class MdlListItemSubTitleComponent implements OnInit {

  constructor( private mdlListItemComponent: MdlListItemPrimaryContentComponent) {}

  public ngOnInit() {
    if (this.mdlListItemComponent === null) {
      throw new MdlStructureError('mdl-list-item-sub-title', 'mdl-list-item-primary-content');
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-list-item-sub-title',
  host: {
    '[class.mdl-list__item-sub-title]': 'true'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdlListItemPrimaryContentComponent, decorators: [{ type: Optional }, ]},
];
}


export class MdlListItemSecondaryInfoComponent implements OnInit {

  constructor( private mdlListItemComponent: MdlListItemSecondaryContentComponent) {}

  public ngOnInit() {
    if (this.mdlListItemComponent === null) {
      throw new MdlStructureError('mdl-list-item-secondary-info', 'mdl-list-item-secondary-content');
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-list-item-secondary-info',
  host: {
    '[class.mdl-list__item-secondary-info]': 'true'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdlListItemSecondaryContentComponent, decorators: [{ type: Optional }, ]},
];
}


export class MdlListItemTextBodyComponent implements OnInit {

  constructor( private mdlListItemComponent: MdlListItemComponent) {}

  public ngOnInit() {
    if (this.mdlListItemComponent === null) {
      throw new MdlStructureError('mdl-list-item-text-body', 'mdl-list-item');
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-list-item-text-body',
  host: {
    '[class.mdl-list__item-text-body]': 'true'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdlListItemComponent, decorators: [{ type: Optional }, ]},
];
}



export class MdlListItemIconDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mdl-icon[mdl-list-item-icon]',
  host: {
    '[class.mdl-list__item-icon]': 'true'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class MdlListItemAvatarDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mdl-icon[mdl-list-item-avatar]',
  host: {
    '[class.mdl-list__item-avatar]': 'true'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

const MDL_LIST_DIRECTIVES = [
  MdlListComponent,
  MdlListItemComponent,
  MdlListItemPrimaryContentComponent,
  MdlListItemIconDirective,
  MdlListItemAvatarDirective,
  MdlListItemSecondaryContentComponent,
  MdlListItemSecondaryActionComponent,
  MdlListItemSubTitleComponent,
  MdlListItemSecondaryInfoComponent,
  MdlListItemTextBodyComponent
];



export class MdlListModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: MdlListModule,
      providers: []
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [],
  exports: MDL_LIST_DIRECTIVES,
  declarations: MDL_LIST_DIRECTIVES,
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
